import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { EventEmitterService } from '../../__common/event-emitter.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  translatedText;
  currentLanguage;

  constructor(private translate: TranslateService,private eventEmitterService: EventEmitterService) {}

  getTranslatedString(key: string): Observable<string> {
    return this.translate.get(key);
  }

  getTranslatedText(key: string) {
    this.getTranslatedString(key).subscribe((translation: string) => {
      this.translatedText = translation;
      return this.translatedText;
    });
    return this.translatedText;
  }

  setLanguage(language){
    this.translate.use(language);
    this.currentLanguage = language;
  }

  getCurrentLanguage(){
    return this.currentLanguage;
  }

  toggleLanguage() {
    this.currentLanguage == 'en'? this.currentLanguage = 'es' : this.currentLanguage = 'en';
    this.translate.use(this.currentLanguage);
    this.eventEmitterService.onLanguageChange(this.currentLanguage);
  }

  translateType(type){
    switch(type){
      case 'electrocution':
        return this.getTranslatedText('IncidentReport.Shock');
      case 'car_collision':
        return this.getTranslatedText('IncidentReport.CarCollision');
      case 'dog_attack':
        return this.getTranslatedText('IncidentReport.DogAttack');
      case 'other':
        return this.getTranslatedText('IncidentReport.Other');
    }
  }

  switchLang(){
    this.currentLanguage == 'en'? this.currentLanguage = 'es' : this.currentLanguage = 'en';
    this.setLanguage(this.currentLanguage);
    this.translate.use(this.currentLanguage);
  }

}